import urls from './urls'
import Service from '@/utils/fetch'

/**
 * 
 */


export function _getJobList(data) {
    return Service({
        url:urls.getJobList,
        data
    })
}

export function _getAccountList(data) {
    return Service({
        url:urls.getAccountList,
        data
    })
}

export function _getUnitListForCreate(data) {
    return Service({
        url:urls.getUnitListForCreate,
        data
    })
}

export function _createOrEditAccount(data) {
    return Service({
        url:urls.createOrEditAccount,
        data
    })
}

export function _stopOrReuseAccount(data) {
    return Service({
        url:urls.stopOrReuseAccount,
        data
    })
}

export function _unbindAcount(data) {
    return Service({
        url:urls.unbindAcount,
        data
    })
}

export function _deleteAccount(data) {
    return Service({
        url:urls.deleteAccount,
        data
    })
}

export function _confirmEnterpriseCustomer(data) {
    return Service({
        url:urls.confirmEnterpriseCustomer,
        data
    })
}





// WEBPACK FOOTER //
// ./src/api/Operation/index.js